__turbopack_context__.v({
  "layoutRestrictedBackground": "layoutRestrictedBackground-module__fI70Fa__layoutRestrictedBackground",
});
